export default "__VITE_PUBLIC_ASSET__cf74e464__"